import { Rule } from "antd/es/form";

export const REQUIRED_RULE: Rule = {
    required: true,
    message: "This field is required."
};